import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AppLayout from "./AppLayout";
import Dashboard from "./dashboard";
import SchemeTypeMapping from "./SchemeTypeMapping";
import ArnCreation from "./arn_creation";
import DistributorLogin from "./DistributorLogin";
import ManageFamilyGroup from "./managefamilygroup";
import FamilyLedgerView from "./components/ledger/FamilyLedgerView";
import LedgerView from "./components/ledger/LedgerView";
import UploadHealthPolicy from "./UploadHealthPolicy";
import AMCSchemeReport from "./AMCSchemeReport";
import ClientMasterReport from "./ClientMasterReport";
import ReportDownloads from "./ReportDownloads";
import ChangeArnPassword from "./ChangeArnPassword";
import AppLayoutForClient from "./AppLayoutForClient";
import DashboardForClient from "./DashboardForClient";
import ClientLogin from "./ClientLogin";
import AppUpdateGate from "./components/AppUpdateGate";
import { IS_MFD_APP, IS_MYWEALTH_APP } from "./config/appVariant";

function App() {
  return (
    <AppUpdateGate>
      <BrowserRouter>
        <Routes>
          {/* MFD routes: included in the MFD app and in the normal website build. */}
          {!IS_MYWEALTH_APP && (
            <>
              <Route path="/login" element={<DistributorLogin />} />
              <Route path="/" element={<AppLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="ledger" element={<LedgerView />} />
                <Route path="family_ledger" element={<FamilyLedgerView />} />
                <Route path="amc-scheme-report" element={<AMCSchemeReport />} />
                <Route path="schemetypemapping" element={<SchemeTypeMapping />} />
                <Route path="managefamilygroup" element={<ManageFamilyGroup />} />
                <Route path="arn_creation" element={<ArnCreation />} />
                <Route path="change-arn-password" element={<ChangeArnPassword />} />
                <Route path="upload-health-policy" element={<UploadHealthPolicy />} />
                <Route path="client-master-report" element={<ClientMasterReport />} />
                <Route path="report-downloads" element={<ReportDownloads />} />
              </Route>
            </>
          )}

          {/* Client routes: included in the MyWealth app and in the normal website build. */}
          {!IS_MFD_APP && (
            <>
              <Route path="/client/login" element={<ClientLogin />} />
              <Route path="/client" element={<AppLayoutForClient />}>
                <Route path="dashboard" element={<DashboardForClient />} />
              </Route>
            </>
          )}

          {/* Mobile variants stay inside their own login realm. */}
          {IS_MFD_APP && (
            <Route path="*" element={<Navigate to="/login" replace />} />
          )}
          {IS_MYWEALTH_APP && (
            <Route path="*" element={<Navigate to="/client/login" replace />} />
          )}
        </Routes>
      </BrowserRouter>
    </AppUpdateGate>
  );
}

export default App;
